export const GET_ALL_LOCATIONS = "GET_ALL_LOCATIONS";
export const GET_ALL_LOCATIONS_RESPONSE_SUCCESS =
  "GET_ALL_LOCATIONS_RESPONSE_SUCCESS";
